import { Footer } from "../components/Footer";
import { Icon } from "../components/Icon";
import { Layout } from "../components/Layout";
import { Link, graphql } from "gatsby";
import * as React from "react";
import { Helmet } from "react-helmet";

export default class Industries extends React.Component<any, any> {
  render() {
    const { allBrandsJson } = this.props.data;

    const brands = allBrandsJson.edges;

    return (
      <Layout location={this.props.location}>
        <main id="main" className="marketing-content container-fluid">
          <Helmet
            bodyAttributes={{
              class: "body-shorthand body-marketing body-marketing-secondary body-marketing-features body-light hide-elevio",
            }}
          ></Helmet>
          <div className="row section-title title-light">
            <div className="col-11 col-sm-8  mx-auto section-inner">
              <h1>
                <span className="shorthand-logo dark" aria-hidden="true">
                  Shorthand
                </span>
                Shorthand for <em>your</em> industry
              </h1>
              <h2>Digital storytelling for marketing, media, and communications teams.</h2>
            </div>
          </div>
          <section className="row section section-strip section-strip-left">
            <div className="container container-sm">
              <div className="section-strip-col section-strip-col-text">
                <div className="section-strip-col-text-inner">
                  <h3>
                    <Link to="/industries/brand-publishing/" className="unstyled">
                      Brand publishing
                    </Link>
                  </h3>
                  <p>Create beautiful, immersive content that deeply engages readers with your brand, products, and service.</p>
                  <p>
                    Easily produce fully-responsive, high-performance pages, and then publish to your website or CMS with one click
                    &mdash; all without a single line of code.
                  </p>

                  <Link className="btn btn-secondary" to="/industries/brand-publishing/">
                    Learn more
                    <span className="hide-sm"> about Shorthand for brand publishing</span>
                  </Link>
                </div>
              </div>

              <div className="section-strip-col">
                <img src="/media/industries/engine-right-white.jpg" alt="" aria-hidden="true" />
              </div>
            </div>
          </section>
          <section className="row section section-strip section-strip-right">
            <div className="container container-sm">
              <div className="section-strip-col section-strip-col-text">
                <div className="section-strip-col-text-inner">
                  <h3>
                    <Link to="/industries/media/" className="unstyled">
                      Media and journalism
                    </Link>
                  </h3>
                  <p>When telling important stories, the world's most trusted media brands trust Shorthand.</p>
                  <p>Build interactive and award winning stories that have your readers engaged for longer. No developers required.</p>
                  <Link className="btn btn-secondary" to="/industries/media/">
                    Learn more
                    <span className="hide-sm"> about Shorthand for media & journalism</span>
                  </Link>
                </div>
              </div>
              <div className="section-strip-col">
                <img src="/media/industries/bbc-grid-grey.jpg" alt="" aria-hidden="true" />
              </div>
            </div>
          </section>
          <section className="row section section-strip section-strip-left">
            <div className="container container-sm">
              <div className="section-strip-col section-strip-col-text">
                <div className="section-strip-col-text-inner">
                  <h3>
                    <Link to="/industries/corporate-comms/" className="unstyled">
                      Corporate communications
                    </Link>
                  </h3>
                  <p>
                    Breathe life into your corporate and internal communications with attention-grabbing, visually immersive digital
                    stories.
                  </p>
                  <p>
                    Inspire your staff, inform your stakeholders, and delight the public with stories that are easily created and
                    securely published.
                  </p>
                  <Link className="btn btn-secondary" to="/industries/corporate-comms/">
                    Learn more
                    <span className="hide-sm"> about Shorthand for corporate comms</span>
                  </Link>
                </div>
              </div>
              <div className="section-strip-col">
                <img src="/media/industries/culture-right.jpg" alt="" aria-hidden="true" />
              </div>
            </div>
          </section>
          <section className="row section section-strip section-strip-right">
            <div className="container container-sm">
              <div className="section-strip-col section-strip-col-text">
                <div className="section-strip-col-text-inner">
                  <h3>
                    <Link to="/industries/education/" className="unstyled">
                      Higher education
                    </Link>
                  </h3>
                  <p>
                    Engage your entire university community &mdash; including students, faculty, staff, and donors &mdash; with
                    stunning, visually immersive digital stories.
                  </p>
                  <p>
                    Shorthand powers digital magazines, research reports, and campus promotion for many of the world's leading schools
                    and universities.
                  </p>

                  <Link className="btn btn-secondary" to="/industries/education/">
                    Learn more
                    <span className="hide-sm"> about Shorthand for Education</span>
                  </Link>
                </div>
              </div>
              <div className="section-strip-col">
                <img src="/media/industries/edu-left-grey.jpg" alt="" aria-hidden="true" />
              </div>
            </div>
          </section>
          <section className="row section section-strip section-strip-left">
            <div className="container container-sm">
              <div className="section-strip-col section-strip-col-text">
                <div className="section-strip-col-text-inner">
                  <h3>
                    <Link to="/industries/government/" className="unstyled">
                      Government communications
                    </Link>
                  </h3>
                  <p>
                    Promote public policy, events, and initiatives through multimedia stories that are highly engaging and natively
                    accessible on all devices.
                  </p>
                  <p>Create and deliver powerful stories quickly, easily, and securely to move the dial on the matters that matter.</p>

                  <Link className="btn btn-secondary" to="/industries/government/">
                    Learn more
                    <span className="hide-sm"> about Shorthand for Government</span>
                  </Link>
                </div>
              </div>
              <div className="section-strip-col">
                <img src="/media/industries/london-right-white.jpg" alt="" aria-hidden="true" />
              </div>
            </div>
          </section>

          <section className="row section section-strip section-strip-right">
            <div className="container container-sm">
              <div className="section-strip-col section-strip-col-text">
                <div className="section-strip-col-text-inner">
                  <h3>
                    <Link to="/industries/ngo/" className="unstyled">
                      NGOs
                    </Link>
                  </h3>
                  <p>
                    Drive change, activate donors, and nurture volunteers with stunning feature stories, landing pages, and annual
                    reports.
                  </p>
                  <p>The world’s leading non-profits and NGOs rely on Shorthand to transform attention into action.</p>

                  <Link className="btn btn-secondary" to="/industries/ngo/">
                    Learn more
                    <span className="hide-sm"> about Shorthand for NGOs</span>
                  </Link>
                </div>
              </div>
              <div className="section-strip-col">
                <img src="/media/industries/msf-left-grey.jpg" alt="" aria-hidden="true" />
              </div>
            </div>
          </section>
          <section className="row section  section-strip section-strip-quote ">
            <div className="container container-sm">
              <div className="section-strip-col-single section-strip-single-quote">
                <div className="section-strip-quote-inner">
                  <blockquote>
                    &ldquo;Shorthand is so intuitive as a system that absolute beginners can design really compelling looking content
                    in no time at all. We love Shorthand &mdash; long may she reign!&rdquo;
                  </blockquote>
                  <div className="section-strip-quote-rating">
                    <ul>
                      <li>
                        <Icon icon="star" />
                      </li>
                      <li>
                        <Icon icon="star" />
                      </li>
                      <li>
                        <Icon icon="star" />
                      </li>
                      <li>
                        <Icon icon="star" />
                      </li>
                      <li>
                        <Icon icon="star" />
                      </li>
                    </ul>
                  </div>
                  <cite>&mdash; Reviewer on G2</cite>
                  <a
                    href="https://www.g2.com/products/shorthand/reviews"
                    target="_blank"
                    rel="norefferer noopener"
                    className="btn btn-secondary"
                  >
                    Read more reviews on G2
                  </a>
                </div>
              </div>
            </div>
          </section>
          <section className="row section section-dark section-half section-trial !tw-bg-[rgba(249,249,249,0.3)]">
            <div className="container section-inner text-center">
              <h2 className="!tw-text-black">
                Ready to try the digital storytelling platform used by Honda, University of Cambridge, and the BBC?
              </h2>

              <div className="cta-container">
                <a href="https://app.shorthand.com/signup" className="btn btn-lg !tw-bg-black hover:!tw-opacity-70">
                  Start creating
                </a>
              </div>
              <div className="brands">
                <div className="brands-container">
                  <h3 className="as-used">Join these iconic brands</h3>
                  <ul>
                    {brands.map((brand, index) => (
                      <li key={`brand-${brand.node.label}-${index}`} className={`brand`}>
                        <img src={brand.node.logo} alt={`${brand.node.label} logo`} />
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <div aria-hidden="true" className="background-media background-media-fixed">
              <img src="/media/home/stories.jpg" className="ObjectFit--cover" alt="" />
            </div>
          </section>

          <Footer className="mt-0" />
        </main>
      </Layout>
    );
  }
}

export const query = graphql`
  query IndustriesQuery {
    site {
      siteMetadata {
        name
        title
        tagline
        description
      }
    }
    allBrandsJson {
      edges {
        node {
          logo
          name
          label
        }
      }
    }
  }
`;
